<template>
    <div
        class="sl-order-form__line-side"
        :class="`sl-order-form__line-side-${side}`"
    >
        <!-- Helper -->
        <div class="sl-order-form__line-band-wrapper">
            <div class="sl-order-form__line-band-content"></div>
        </div>

        <!-- Error Wrapper -->
        <div
            class="sl-order-form__line-content-wrapper"
            :class="{ 'sl-order-form__line-content-wrapper--error': error }"
        >
            <!-- Field Wrapper -->
            <div class="sl-order-form__field-wrapper w-full">
                <!-- Field -->
                <file-uploader
                    :model-value="modelValue"
                    :tab-index="tabIndex"
                    :side="side"
                    :eid="store.state.account.cEntity.id"
                    :fitting-session-id="fittingSessionId"
                    :typeless="typeless"
                    @update:model-value="emit('update:modelValue', $event)"
                />
            </div>

            <!-- Error -->
            <div v-if="error" class="sl-order-form__error-wrapper">
                <div class="sl-order-form__error">
                    {{ error }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { fieldProps, useFieldComposable } from '@/composables/FieldComposable';
import FileUploader from '@/components/FileUploader.vue';
import Fitting from '@/models/Fitting';

const props = defineProps(fieldProps);
const emit = defineEmits(['update:modelValue']);

const store = useStore();
const { tabIndex } = useFieldComposable(props, emit, store);

/** @type {import("vue").ComputedRef<Fitting>} */
const fitting = computed(() => store.getters['lensOrder/getFitting'](props.side));
const fittingSessionId = computed(() => fitting.value.session_id);
const typeless = computed(() =>
{
    const proto = fitting.value.getPrototype();
    const requestPurpose = proto.getValue('LENS_COMMENT_PURPOSE');

    return requestPurpose === 'OTHER';
});
</script>
